import React from 'react';
import { styled } from 'styled-components';
import { MediaSectionDetail } from './MediaSectionDetail';
import { MediaSectionWithShowDetail } from './MediaSectionWithShowDetail';
import { ShowSectionDetail } from './ShowSectionDetail';
import { useSectionDetail } from './use-section-detail';
import { pulsate } from '../../../../play-core/styles/pulsate';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { times } from '../../../../play-core/utils/times';
import { PageNotFound } from '../../../src/pages/Error/PageNotFound';
import { GridView } from '../../components/GridView/GridView';
import { ErrorIfEmpty } from '../../components/Message/ErrorIfEmpty';
import { PlayContainer } from '../../components/PlayContainer/PlayContainer';
import { AspectPlaceholder } from '../../components/Teaser/Placeholder/AspectPlaceholder';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionDetailPage = ({
  initialData
}) => {
  const {
    sectionDetailData,
    isLoading,
    notFound
  } = useSectionDetail(initialData);
  return /*#__PURE__*/_jsxs(ErrorIfEmpty, {
    children: [sectionDetailData?.sectionType === 'MediaSectionWithShow' && /*#__PURE__*/_jsx(MediaSectionWithShowDetail, {
      sectionDetail: sectionDetailData
    }), sectionDetailData?.sectionType === 'MediaSection' && /*#__PURE__*/_jsx(MediaSectionDetail, {
      sectionDetail: sectionDetailData
    }), sectionDetailData?.sectionType === 'ShowSection' && /*#__PURE__*/_jsx(ShowSectionDetail, {
      sectionDetail: sectionDetailData
    }), isLoading && /*#__PURE__*/_jsxs(PlayContainer, {
      children: [/*#__PURE__*/_jsx(Layout, {}), /*#__PURE__*/_jsx(GridView, {
        children: times(20, index => /*#__PURE__*/_jsx(AspectPlaceholder, {
          aspectRatio: 16 / 9
        }, index))
      })]
    }), notFound && /*#__PURE__*/_jsx(PageNotFound, {})]
  });
};
const Layout = styled.div.withConfig({
  displayName: "SectionDetailPage__Layout",
  componentId: "sc-bx5ltr-0"
})(["animation:", " 1s ease-in-out infinite alternate;height:200px;", "{height:280px;}", "{height:300px;}", "{height:360px;}"], pulsate, Viewports.for('medium'), Viewports.for('large'), Viewports.for('xLargeUp'));